import React, { useEffect, useState } from "react";
import { useApiClient } from "../../../shared/customHooks";
import { adminNotesForm } from "../../../shared/formObjects/application/adminNotesForm";
import FormContainer from "../../form/FormContainer";
import { useApplicationContext } from "../context/applicationContext";
import ComponentHeader, { ComponentHeaderProps } from "../../componentHeader/componentHeader";

function AdminNotesComponent({ disabled, data, showEdit, showBack, backPath }: any) {
  const api = useApiClient("AdministrativeNotes");
  const { id } = useApplicationContext();

  const [headerData, setHeaderData] = useState<ComponentHeaderProps>({
    showEdit: showEdit ?? disabled,
    editPath: `${location.pathname}/${"adminNotes"}`,
    showBack: showBack ?? (!disabled && backPath != null),
    backPath: backPath,
  });

  function getHeaderData() {
    location;
    const headerData: ComponentHeaderProps = {
      showEdit: showEdit ?? disabled,
      editPath: `${location.pathname}/${"adminNotes"}`,
      showBack: showBack ?? !disabled,
      backPath: backPath ?? "..",
    };
    setHeaderData(headerData);
  }

  useEffect(() => {
    getHeaderData();
  }, []);

  return (
    <>
      <ComponentHeader {...headerData} label={"Administrative Notes"} />
      <FormContainer
        id={id}
        apiClient={api}
        formBody={adminNotesForm}
        disabled={disabled}
        data={data}
        submitRoute=".."
        showInternalNotes={false}
        hidden={!data?.adminNotes && location.pathname == `/applications/${id}`}
      />
    </>
  );
}

export default AdminNotesComponent;
